import firebaseApp from "../../firebase/credenciales";
import { getFirestore, collection, getDocs } from "firebase/firestore";
const db = getFirestore(firebaseApp);

//const {contextData} = useDataContext();
    

export default async function getCostos(productofolio) {
    

  //console.log(valor);
    const costosygastos =  [];
    //console.log(valor);
    const collectionRef = collection(db, "Gastos".replace(/ /g, ""));
    const snapshot = await getDocs(collectionRef);
    snapshot.forEach((doc) => {
      costosygastos.push(doc.data());
    });
    return costosygastos;
    

}


//"+productofolio+"
